import { createRouter, createWebHistory } from 'vue-router';
import { cruisesRoutes } from './routes';

export const cruises = createRouter({
  history: createWebHistory(),
  routes: cruisesRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.path === from.path) {
      return false;
    }

    return { top: 0 };
  },
});
